import React from 'react';
import SideMenu from '../components/SideMenu';
import Header from '../components/Header';
import UserMenu from '../components/UserMenu';
import thumbimg from '../assets/images/thumbimg.png'
import TokenRegistrationTable from '../components/TokenRegistrationTable';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Checkbox, FormControlLabel, TextField, Radio, RadioGroup, FormControl, FormLabel } from '@mui/material';

const ModifyPartyDetailsBeforeReg = () => {
  return (
    <div className="flex h-screen">
    <SideMenu />
    <div className="flex-1 flex flex-col">
        <Header />
        <div className="flex flex-1">
            {/* Left Side */}
            <div className="flex-1 p-4">
  <div className="max-w-5xl mx-auto p-4 bg-secondary-50 rounded-md shadow-md">
    <h2 className="text-xl font-semibold mb-4">FRM Party Details</h2>

    <div className="flex flex-cols-3 gap-2 mb-6 items-start">
      <div className="bg-secondary-100 col-span-1">
        <div className="bg-gray-200 p-2 rounded text-sm">
          <span className="font-semibold">Token Date:</span> 18, July 2024
        </div>
      </div>
      <div className="bg-secondary-100 col-span-1">
        <div className="bg-gray-200 p-2 rounded text-sm">
          <span className="font-semibold">Token No.:</span> 36
        </div>
      </div>
      <div className="bg-secondary-100 col-span-1">
        <div className="bg-gray-200 p-2 rounded text-sm">
          <span className="font-semibold">Party Code:</span> 123
        </div>
      </div>
    </div>

    <div className="flex flex-row">
  <div className="grid grid-cols-3 gap-4">
    <div className="col-span-2">
      <label className="block font-semibold mb-1">Name</label>
      <input type="text" className="w-full p-2 border rounded" />
    </div>
    <div className="col-span-1">
      <label className="block font-semibold mb-1">Relation</label>
      <input type="text" className="w-full p-2 border rounded" />
    </div>
    <div className="col-span-2">
      <label className="block font-semibold mb-1">Relation's Name</label>
      <input type="text" className="w-full p-2 border rounded" />
    </div>
    <div className="col-span-1">
      <label className="block font-semibold mb-1">Other Name</label>
      <input type="text" className="w-full p-2 border rounded" />
    </div>
    <div className="col-span-1">
      <label className="block font-semibold mb-1">Occupation</label>
      <input type="text" className="w-full p-2 border rounded" />
    </div>
    <div className="col-span-1">
      <label className="block font-semibold mb-1">PAN/Form 60</label>
      <input type="text" className="w-full p-2 border rounded" />
    </div>
    <div className="col-span-1 flex items-end">
      <button className="p-2 bg-blue-500 text-white rounded">+ THUMB</button>
    </div>
    <div className="col-span-2">
      <label className="block font-semibold mb-1">Address</label>
      <textarea
        className="w-full p-2 border rounded"
        rows={1}
        style={{overflow: 'hidden' }}
        // onInput={(e) => {
        //   const target = e.target as HTMLTextAreaElement;
        //   target.style.height = 'auto';
        //   target.style.height = `${target.scrollHeight}px`;
        // }}
      />
    </div>
  </div>
  <div className="mt-5 mx-2">
    <div className="bg-white flex items-center justify-center border">
      <img src={thumbimg} alt="Thumb Image" className="h-20 w-20 object-cover" />
    </div>
  </div>
</div>



    <div className="mt-6 text-center">
      <button className="px-6 py-2 bg-blue-500 text-white rounded">Update</button>
    </div>
  </div>
</div>


            {/* Right Side */}
            <div className="w-64 h-full">
                <UserMenu />
            </div>
        </div>
    </div>
</div>
  )
}

export default ModifyPartyDetailsBeforeReg
